import { useCallback, useMemo } from "react";

import { useTypedSelector } from "../../redux/store";
import { useCarParkFilterAccessControl } from "..";

function useCarParkIdsDecoder() {
	const { isUserFleetOwner, accessFleetsIdsOnlyActive: accessIds } =
		useCarParkFilterAccessControl<any>();

	const modelsCarPark = useTypedSelector(
		(state) => state.globalState.carPark.data.subscription.basic,
	);

	const availableIds = useMemo(
		() => modelsCarPark.map((item) => item.id),
		[modelsCarPark],
	);

	const isAllIds = useCallback(
		(
			taxiServices: useCarParkIdsDecoder.EncodedIds = [],
		): taxiServices is ["all"] => taxiServices?.[0] === "all",
		[],
	);

	const decoder = useCallback(
		(
			companyIds: useCarParkIdsDecoder.EncodedIds = [],
			options: useCarParkIdsDecoder.DecoderOptions = {},
		) => {
			const isOnlyAccessIds = isUserFleetOwner ? accessIds : availableIds;

			if (isAllIds(companyIds) && companyIds) return isOnlyAccessIds;

			return (
				isOnlyAccessIds?.filter((companyId) =>
					companyIds?.includes(companyId),
				) || []
			);
		},
		[accessIds, availableIds, isAllIds, isUserFleetOwner],
	);

	return decoder;
}

declare namespace useCarParkIdsDecoder {
	type EncodedIds = number[] | ["all"];

	interface DecoderOptions {
		// isOnlyAccess?: boolean;
	}
}

export default useCarParkIdsDecoder;
